
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "deletePipeline",
      resolverType: "mutation",
      routePath: "/deletePipeline",
      httpMethod: "POST",
    });
  